<div
  *ngIf="!is_list_running"
  class="sp-width__full sp-height__full sp-background__accent-contrast sp-border-radius__s sp-padding__x2">
  <app-home-header
    icon="person"
    [title]="'SHARED.TOOLBAR_BUYERS_LABEL'"
    (refresh)="onRefresh()"
    (see_all)="onSeeAllClick()"></app-home-header>

  <div class="sp-margin__top-x2"></div>
  <div
    *ngFor="let buyer of buyers"
    class="sp-padding__vert sp-width__full">
    <app-home-buyers-item [buyer]="buyer"></app-home-buyers-item>
  </div>

  <app-shared-empty-message
    *ngIf="!buyers?.length"
    [empty_message]="'BUYERS.EMPTY_MESSAGE'"></app-shared-empty-message>
</div>

<div
  *ngIf="is_list_running"
  class="sp-width__full sp-height__full">
  <app-loading [card_radius]="'sp-border-radius__s'"></app-loading>
</div>
